import axios from "@/api/axiosInstance";
import { GetFileManagerMetaDataResponse } from "./types";

export const getFileManagerMetaData = async (
  folderUuid?: string | null,
  recursive?: boolean,
): Promise<GetFileManagerMetaDataResponse> => {
  const params: Record<string, string | boolean> = {};
  if (folderUuid) {
    params.folderUuid = folderUuid;
  }
  if (recursive !== undefined) {
    params.recursive = recursive;
  }

  const response = await axios.get<GetFileManagerMetaDataResponse>(
    "/api/private/file-management/metadata",
    { params },
  );
  return response.data;
};
